import { axios, AxiosResponse } from "@sdk/axios";

export interface iSendMessageBody {
  conversationId: string;
  messageText: string;
}

export class BrowserUseTaskServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {}

  browserUseTasks = {
    sendMessage: async (
      body: iSendMessageBody,
    ): Promise<{ success: boolean; output?: string }> => {
      const results: AxiosResponse<{
        success: boolean;
        output?: string;
      }> = await axios.post(
        this.config.basePath + "/browser-use-tasks/send-message",
        body,
        {
          headers: {
            Authorization: this.config.token,
          },
        },
      );
      return results.data;
    },
  };
}
